import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftShow20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSidebarLeftShow20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.51 4.5h8.99a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H7.51zM19 5.5A2.5 2.5 0 0 0 16.5 3h-13A2.5 2.5 0 0 0 1 5.5v9A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5zm-8.056 2.556a.75.75 0 1 1 1.06-1.06L14.48 9.47l.53.53-.53.53-2.474 2.476a.75.75 0 0 1-1.061-1.061L12.888 10z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftShow20Filled);
